import { QUICK_COMMERCE_APIS } from "@/api_framework/api_config";
import {
  IQuickCommercePincodeUpdatePutBody,
  IQuickCommercePincodeUpdateResponse,
} from "@/api_framework/api_modals/QuickCommerce";
import { useQuickCommerce } from "@/app/hooks/useQuickCommerce";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useQuickCommercePincodeUpdateAPI = () => {
  const [updatedPincodeId, setUpdatedPincodeId] = useState<string>("");
  const quickCommerce = useQuickCommerce();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (pincodeData: IQuickCommercePincodeUpdatePutBody, cityId: string) => {
      try {
        const accessToken = localStorage.getItem(quickCommerce.localStorage.ACCESS_TOKEN.key);
        if (!pincodeData) {
          return;
        }
        await axios
          .put(`${QUICK_COMMERCE_APIS?.PINCODE_UPDATE?.baseURL}${cityId}` ?? "", JSON.stringify(pincodeData), {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IQuickCommercePincodeUpdateResponse>) => {
            if (res.data.status === true) {
              setUpdatedPincodeId(res?.data?.data?.pincode);
              toast.success(`Pincode ${pincodeData?.pincode} , Updated successfully. `);
            } else {
              // console.log("not created");
              toast.error("Cannot create pincode.");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while creating pincode.");
          }
          // if (axiosError.response?.status === 400) {
          //   toast.error(axiosError.message);
          // }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, quickCommerce],
  );

  return { updatedPincodeId, execute };
};
